class Cursor {
	constructor() {
		// Don't initiate if hover interactions aren't supported
		this.hoverSupported = window.matchMedia("(hover: hover)").matches;
		if (!this.hoverSupported) {
			// console.warn('Hover interactions are not supported on this device.');
			return;
		}

		this.cursor = document.querySelector('.jsCursor');
		if (!this.cursor) {
			console.warn('Cursor element not found')
			return;
		}

		// this.cursor.showPopover();
		this.init();
	}

	init() {
		window.addEventListener('mousemove', (e) => this.handleCursorMove(e));
	}

	handleCursorMove(e) {
		// const cursorX = e.clientX;
		// const cursorY = e.clientY;
		const { clientX: cursorX, clientY: cursorY } = e;
		// document.documentElement.style.setProperty('--cursorX', `${cursorX}px`);
		// document.documentElement.style.setProperty('--cursorY', `${cursorY}px`);
		this.cursor.style.translate = `${cursorX}px ${cursorY}px`;
	}
}

let customCursor = new Cursor();